import { getDocument } from "./exporters/pdfExporter";
import { language } from "language/default";
import { CustomColumnType } from "./grid-column-types";
import { formatMoneyCellValue } from "./renderers/moneyCellRenderer";
import { serializeColumnState } from "./insGrid-column-state";
import { createHandleColumnGroupOpened } from "./insGrid-events";
import { saveState } from "store/grids";
export const getContentForPdf = (grid, props, widgetSettings, pageAvailableWidth) => getDocument(grid.current?.api, props.rowData?.length ?? 0, widgetSettings, pageAvailableWidth);
export const handleColumnGroupOpenedHelper = (grid, dispatch, props, event) => {
    createHandleColumnGroupOpened(grid);
    const groupId = event.columnGroup?.getGroupId();
    const isGroupExpanded = event.columnGroup?.isExpanded();
    const currentColumnState = event.api.getColumnState();
    const groupedColumns = event.api.getColumnDefs()?.find((col) => col.groupId === groupId);
    const serializableColumnState = serializeColumnState(currentColumnState);
    const mergedColumn = serializableColumnState.map((newCol) => {
        const existingCol = groupedColumns?.children?.find((col) => col.colId === newCol.colId);
        if (existingCol) {
            if (newCol.groupedColumnContext) {
                const index = newCol.groupedColumnContext.findIndex((context) => context.groupId === groupId);
                return {
                    ...newCol,
                    groupedColumnContext: index > -1
                        ? [...newCol.groupedColumnContext.splice(index, 1).length > 0 ? newCol.groupedColumnContext : [], { groupId, isGroupExpanded }]
                        : [{ groupId, isGroupExpanded }]
                };
            }
            return { ...newCol, groupedColumnContext: [{ groupId, isGroupExpanded }] };
        }
        return newCol;
    });
    dispatch(saveState({ columns: mergedColumn, id: props.stateId }));
};
export const handleGridReadyHelper = (event, gridColumnState) => {
    if (gridColumnState) {
        const groupIds = gridColumnState.flatMap((col) => {
            if (col.groupedColumnContext) {
                return col.groupedColumnContext
                    .map((c) => ({ groupId: c.groupId, isGroupExpanded: c.isGroupExpanded }));
            }
            return [];
        }).filter((item, index, arr) => arr.findIndex((v) => v.groupId === item.groupId && v.isGroupExpanded === item.isGroupExpanded) === index);
        if (groupIds.length) {
            groupIds.forEach(({ groupId, isGroupExpanded }) => {
                if (groupId && isGroupExpanded) {
                    event.api.setColumnGroupOpened(groupId, isGroupExpanded);
                }
            });
        }
    }
};
export const exportExcel = (grid, props, dataScale) => {
    grid.current?.api.setColumnsVisible(["checkboxCol"], false);
    grid.current?.api.setColumnsVisible(["tags"], false);
    const allColumns = grid.current?.api.getAllDisplayedColumns() ?? [];
    const columnKeys = allColumns.filter((col) => !col.getColDef().skipExcelExport);
    grid.current?.api.exportDataAsExcel({
        author: "",
        columnKeys,
        fileName: `InsightExport_${props.exportExcelName}`,
        processCellCallback: (params) => {
            const colDef = params.column.getColDef();
            if (colDef.type === CustomColumnType.InsMoneyColumn) {
                return formatMoneyCellValue(params.value, dataScale);
            }
            return params.value;
        },
        sheetName: language.en.grid.excelExportSheetName
    });
    grid.current?.api.setColumnsVisible(["checkboxCol"], true);
    grid.current?.api.setColumnsVisible(["tags"], true);
};
